import React from 'react'

export default function Preferences() {
    return (
        <div>
            <h2>Preferences</h2>
        </div>
    )
}
